import { apiSlice } from "./apiSlice";

export const verifyOTPApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    verifyOTP: builder.mutation({
      query: body => ({
        url:"/api/v3/crm/passwords/verify_otp",
        method: "POST",
        body: JSON.parse(JSON.stringify(body)),
      }),
    }),
  }),
});

export const {useVerifyOTPMutation} = verifyOTPApiSlice;
